import React from 'react';
import displayName from 'component-lib/displayName';
import styles from './AppHeader.scss';
import userPropTypes from './propTypes/user';

export default function UserInfoDisplay({ user: { name, role, withImage = true } }) {
    return (
        <div className={styles['my-account']}>
            {withImage && <div className={styles['my-avatar']} />}
            <div className={styles['my-info']}>
                <span className={styles['my-name']}>
                    {name}
                </span>
                <span className={styles['my-role']}>
                    {role}
                </span>
            </div>
        </div>
    );
}

UserInfoDisplay.displayName = displayName('AppHeader/UserInfoDisplay');

/* eslint-disable react/require-default-props */

UserInfoDisplay.propTypes = {
    user: userPropTypes,
};
